"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var ethers_1 = require("ethers");
var util_1 = require("../../common/util");
var config_1 = require("../config");
var ETH_ADDRESS = "0x0000000000000000000000000000000000000000";
var ONE = ethers_1.ethers.BigNumber.from(10).pow(18);
var REQUEST_LIMIT = 100;
var TIMEOUT_LIMIT = 30;
var ERROR = function () { return new Error("Milkomeda bridge provider error"); };
var MilkomedaBridgeAbi = require("./MilkomedaBridgeAbi.json");
var IERC20Abi = require("../../common/ethereum/IERC20Abi.json");
var MilkomedaBridgeProvider = /** @class */ (function () {
    function MilkomedaBridgeProvider() {
    }
    Object.defineProperty(MilkomedaBridgeProvider.prototype, "name", {
        get: function () {
            return MilkomedaBridgeProvider._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MilkomedaBridgeProvider, "bridgeAbi", {
        get: function () {
            return MilkomedaBridgeProvider._bridgeAbi;
        },
        enumerable: false,
        configurable: true
    });
    MilkomedaBridgeProvider.prototype.request = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var networkEndpoint, error_1;
            var _c = _b.body, body = _c === void 0 ? null : _c, _d = _b.endpoint, endpoint = _d === void 0 ? "" : _d, _e = _b.networkId, networkId = _e === void 0 ? 0 : _e, _f = _b.headers, headers = _f === void 0 ? {} : _f, _g = _b.method, method = _g === void 0 ? "GET" : _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        networkEndpoint = networkId == 0 ?
                            'https://ada-bridge-devnet-cardano-evm.c1.milkomeda.com/api/v1' :
                            'https://ada-bridge-mainnet-cardano-evm-us.c1.milkomeda.com/api/v1';
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(networkEndpoint).concat(endpoint), {
                                headers: __assign({}, headers),
                                method: method,
                                body: body
                            })];
                    case 2: return [4 /*yield*/, (_h.sent()).json()];
                    case 3: return [2 /*return*/, _h.sent()];
                    case 4:
                        error_1 = _h.sent();
                        // console.error(error);
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MilkomedaBridgeProvider.prototype.getBridgeTxFor = function (txId_1) {
        return __awaiter(this, arguments, void 0, function (txId, networkId) {
            var toCondition, fromCondition, bridgeInfo, i;
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (String(txId).startsWith("0x")) {
                            toCondition = "tx_id";
                            fromCondition = "mainchain_tx_id";
                        }
                        else {
                            toCondition = "mainchain_tx_id";
                            fromCondition = "transaction_id";
                        }
                        return [4 /*yield*/, this.request({
                                endpoint: "/requests?".concat(toCondition, "=").concat(txId),
                                networkId: networkId,
                                method: "GET"
                            })];
                    case 1:
                        bridgeInfo = _a.sent();
                        // console.log(0, bridgeInfo);
                        if (bridgeInfo.requests.length > 0 && bridgeInfo.requests[0][fromCondition] !== "") {
                            return [2 /*return*/, bridgeInfo.requests[0][fromCondition]];
                        }
                        i = 1;
                        _a.label = 2;
                    case 2:
                        if (!(i < REQUEST_LIMIT)) return [3 /*break*/, 6];
                        return [4 /*yield*/, (0, util_1.awaitTimeout)(TIMEOUT_LIMIT * 1000)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.request({
                                endpoint: "/requests?".concat(toCondition, "=").concat(txId),
                                networkId: networkId,
                                method: "GET"
                            })];
                    case 4:
                        bridgeInfo = _a.sent();
                        // console.log(i, bridgeInfo);
                        if (bridgeInfo.requests.length > 0 && bridgeInfo.requests[0][fromCondition] !== "") {
                            return [2 /*return*/, bridgeInfo.requests[0][fromCondition]];
                        }
                        _a.label = 5;
                    case 5:
                        ++i;
                        return [3 /*break*/, 2];
                    case 6: throw ERROR();
                }
            });
        });
    };
    MilkomedaBridgeProvider.prototype.approveForBridge = function (asset, from, to, signer) {
        return __awaiter(this, void 0, void 0, function () {
            var bridgeConfig, amount, tokenContract, allowanceAmount, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        bridgeConfig = config_1.bridgeConfigs[config_1.BridgeName.Milkomeda][from.chain][to.chain];
                        if (!bridgeConfig) {
                            throw new Error("Bridge config is undefiend");
                        }
                        amount = ethers_1.ethers.BigNumber.from(asset.quantity);
                        if (!(asset.token !== ETH_ADDRESS)) return [3 /*break*/, 4];
                        tokenContract = new ethers_1.ethers.Contract(asset.token, IERC20Abi, signer);
                        _b = (_a = tokenContract).allowance;
                        return [4 /*yield*/, signer.getAddress()];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent(), bridgeConfig.address])];
                    case 2:
                        allowanceAmount = _c.sent();
                        if (!amount.gt(allowanceAmount)) return [3 /*break*/, 4];
                        return [4 /*yield*/, tokenContract.connect(signer).approve(bridgeConfig.address, amount, { gasLimit: 1000000 })];
                    case 3: return [2 /*return*/, _c.sent()];
                    case 4: return [2 /*return*/, undefined];
                }
            });
        });
    };
    MilkomedaBridgeProvider.prototype.bridgeFromEVM = function (asset, from, to, signer) {
        return __awaiter(this, void 0, void 0, function () {
            var bridgeConfig, bridgeContract, amount, tokenContract, allowanceAmount, _a, _b, aproveTx, assetId, fromTx, _c, _d, targetNetworkId;
            var _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        bridgeConfig = config_1.bridgeConfigs[config_1.BridgeName.Milkomeda][from.chain][to.chain];
                        if (!bridgeConfig) {
                            throw new Error("Bridge config is undefiend");
                        }
                        bridgeContract = new ethers_1.ethers.Contract(bridgeConfig.address, MilkomedaBridgeAbi, signer);
                        amount = ethers_1.ethers.BigNumber.from(asset.quantity);
                        if (!(asset.token !== ETH_ADDRESS)) return [3 /*break*/, 5];
                        tokenContract = new ethers_1.ethers.Contract(asset.token, IERC20Abi, signer);
                        _b = (_a = tokenContract).allowance;
                        return [4 /*yield*/, signer.getAddress()];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_f.sent(), bridgeConfig.address])];
                    case 2:
                        allowanceAmount = _f.sent();
                        if (!amount.gt(allowanceAmount)) return [3 /*break*/, 5];
                        return [4 /*yield*/, tokenContract.connect(signer).approve(bridgeConfig.address, amount, { gasLimit: 1000000 })];
                    case 3:
                        aproveTx = _f.sent();
                        return [4 /*yield*/, aproveTx.wait()];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5: return [4 /*yield*/, bridgeContract.callStatic.findAssetIdByAddress(asset.token)];
                    case 6:
                        assetId = _f.sent();
                        _d = (_c = bridgeContract.connect(signer)).submitUnwrappingRequest;
                        _e = {
                            assetId: assetId
                        };
                        return [4 /*yield*/, signer.getAddress()];
                    case 7: return [4 /*yield*/, _d.apply(_c, [(_e.from = _f.sent(),
                                _e.to = "0x" + (0, util_1.BufferToHex)(buffer_1.Buffer.from(to.address)),
                                _e.amount = asset.token !== ETH_ADDRESS ? amount : amount.sub(ONE),
                                _e), {
                                gasLimit: 1000000, value: asset.token !== ETH_ADDRESS ? ONE.mul(4) : amount
                            }])];
                    case 8:
                        fromTx = _f.sent();
                        targetNetworkId = from.chain === config_1.ChainName.Milkomeda ? 1 : 0;
                        return [2 /*return*/, {
                                from: {
                                    chain: from.chain,
                                    tx: {
                                        hash: fromTx.hash,
                                        wait: function () {
                                            var args_1 = [];
                                            for (var _i = 0; _i < arguments.length; _i++) {
                                                args_1[_i] = arguments[_i];
                                            }
                                            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                                var _this = this;
                                                if (blockchainProvider === void 0) { blockchainProvider = undefined; }
                                                if (confirmations === void 0) { confirmations = 0; }
                                                return __generator(this, function (_a) {
                                                    return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                                            var _a;
                                                            return __generator(this, function (_b) {
                                                                switch (_b.label) {
                                                                    case 0:
                                                                        _a = resolve;
                                                                        return [4 /*yield*/, fromTx.wait()];
                                                                    case 1:
                                                                        _a.apply(void 0, [(_b.sent()).blockHash]);
                                                                        return [2 /*return*/];
                                                                }
                                                            });
                                                        }); })];
                                                });
                                            });
                                        }
                                    },
                                    fee: {
                                        token: "0x0000000000000000000000000000000000000000",
                                        quantity: "1" + "0".repeat(18)
                                    }
                                },
                                to: {
                                    chain: to.chain,
                                    tx: new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                        var toTxHash;
                                        var _this = this;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.getBridgeTxFor(fromTx.hash, targetNetworkId)];
                                                case 1:
                                                    toTxHash = _a.sent();
                                                    resolve({
                                                        hash: toTxHash,
                                                        wait: function (blockchainProvider_1) {
                                                            var args_1 = [];
                                                            for (var _i = 1; _i < arguments.length; _i++) {
                                                                args_1[_i - 1] = arguments[_i];
                                                            }
                                                            return __awaiter(_this, __spreadArray([blockchainProvider_1], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                                                var _this = this;
                                                                if (confirmations === void 0) { confirmations = 0; }
                                                                return __generator(this, function (_a) {
                                                                    return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                                            var _a;
                                                                            return __generator(this, function (_b) {
                                                                                switch (_b.label) {
                                                                                    case 0:
                                                                                        if (!blockchainProvider) return [3 /*break*/, 2];
                                                                                        _a = resolve;
                                                                                        return [4 /*yield*/, blockchainProvider.getTxBlockHash(toTxHash, targetNetworkId)];
                                                                                    case 1:
                                                                                        _a.apply(void 0, [_b.sent()]);
                                                                                        _b.label = 2;
                                                                                    case 2:
                                                                                        reject("BlockchainProvider is undefiend");
                                                                                        return [2 /*return*/];
                                                                                }
                                                                            });
                                                                        }); })];
                                                                });
                                                            });
                                                        }
                                                    });
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }),
                                    fee: {
                                        token: "0x0000000000000000000000000000000000000000",
                                        quantity: "1" + "0".repeat(18)
                                    }
                                },
                                by: config_1.BridgeName.Milkomeda
                            }];
                }
            });
        });
    };
    MilkomedaBridgeProvider.prototype.bridgeFromEVMExtra = function (assets, from, to, signer) {
        return __awaiter(this, void 0, void 0, function () {
            var bridgeConfig, bridgeContract, gasId, gasAmount, assetAmount, fromTx, assetId, tokenContract, allowanceAmount, _a, _b, aproveTx, value, _c, _d, _e, _f, targetNetworkId;
            var _g, _h;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        bridgeConfig = config_1.bridgeConfigs[config_1.BridgeName.Milkomeda][from.chain][to.chain];
                        if (!bridgeConfig) {
                            throw new Error("Bridge config is undefiend");
                        }
                        bridgeContract = new ethers_1.ethers.Contract(bridgeConfig.address, MilkomedaBridgeAbi, signer);
                        return [4 /*yield*/, bridgeContract.callStatic.findAssetIdByAddress(ETH_ADDRESS)];
                    case 1:
                        gasId = _j.sent();
                        if (!(assets === null || assets === void 0 ? void 0 : assets.token)) return [3 /*break*/, 10];
                        assetAmount = ethers_1.ethers.BigNumber.from(assets.token.quantity);
                        return [4 /*yield*/, bridgeContract.callStatic.findAssetIdByAddress(assets.token.token)];
                    case 2:
                        assetId = _j.sent();
                        tokenContract = new ethers_1.ethers.Contract(assets.token.token, IERC20Abi, signer);
                        _b = (_a = tokenContract).allowance;
                        return [4 /*yield*/, signer.getAddress()];
                    case 3: return [4 /*yield*/, _b.apply(_a, [_j.sent(), bridgeConfig.address])];
                    case 4:
                        allowanceAmount = _j.sent();
                        if (!assetAmount.gt(allowanceAmount)) return [3 /*break*/, 7];
                        return [4 /*yield*/, tokenContract.connect(signer).approve(bridgeConfig.address, assetAmount, { gasLimit: 1000000 })];
                    case 5:
                        aproveTx = _j.sent();
                        return [4 /*yield*/, aproveTx.wait()];
                    case 6:
                        _j.sent();
                        _j.label = 7;
                    case 7:
                        value = void 0;
                        if (assets === null || assets === void 0 ? void 0 : assets.gas) {
                            gasAmount = ethers_1.ethers.BigNumber.from(assets.gas);
                            if (!gasAmount.gte(ONE.mul(3))) {
                                throw new Error("Gas must be equal or more then 3");
                            }
                            value = gasAmount.add(ONE);
                        }
                        else {
                            value = ONE.mul(4);
                        }
                        _d = (_c = bridgeContract.connect(signer)).submitUnwrappingRequest;
                        _g = {
                            assetId: assetId
                        };
                        return [4 /*yield*/, signer.getAddress()];
                    case 8: return [4 /*yield*/, _d.apply(_c, [(_g.from = _j.sent(),
                                _g.to = "0x" + (0, util_1.BufferToHex)(buffer_1.Buffer.from(to.address)),
                                _g.amount = assetAmount,
                                _g), {
                                gasLimit: 1000000,
                                value: value
                            }])];
                    case 9:
                        fromTx = _j.sent();
                        return [3 /*break*/, 13];
                    case 10:
                        gasAmount = ethers_1.ethers.BigNumber.from(assets.gas);
                        if (!gasAmount.gte(ONE.mul(3))) {
                            throw new Error("Gas must be equal or more then 3");
                        }
                        _f = (_e = bridgeContract.connect(signer)).submitUnwrappingRequest;
                        _h = {
                            assetId: gasId
                        };
                        return [4 /*yield*/, signer.getAddress()];
                    case 11: return [4 /*yield*/, _f.apply(_e, [(_h.from = _j.sent(),
                                _h.to = "0x" + (0, util_1.BufferToHex)(buffer_1.Buffer.from(to.address)),
                                _h.amount = gasAmount,
                                _h), {
                                gasLimit: 1000000,
                                value: gasAmount.add(ONE)
                            }])];
                    case 12:
                        fromTx = _j.sent();
                        _j.label = 13;
                    case 13:
                        targetNetworkId = from.chain === config_1.ChainName.Milkomeda ? 1 : 0;
                        return [2 /*return*/, {
                                from: {
                                    chain: from.chain,
                                    tx: {
                                        hash: fromTx.hash,
                                        wait: function () {
                                            var args_1 = [];
                                            for (var _i = 0; _i < arguments.length; _i++) {
                                                args_1[_i] = arguments[_i];
                                            }
                                            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                                var _this = this;
                                                if (blockchainProvider === void 0) { blockchainProvider = undefined; }
                                                if (confirmations === void 0) { confirmations = 0; }
                                                return __generator(this, function (_a) {
                                                    return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                                            var _a;
                                                            return __generator(this, function (_b) {
                                                                switch (_b.label) {
                                                                    case 0:
                                                                        _a = resolve;
                                                                        return [4 /*yield*/, fromTx.wait()];
                                                                    case 1:
                                                                        _a.apply(void 0, [(_b.sent()).blockHash]);
                                                                        return [2 /*return*/];
                                                                }
                                                            });
                                                        }); })];
                                                });
                                            });
                                        }
                                    },
                                    fee: {
                                        token: "0x0000000000000000000000000000000000000000",
                                        quantity: "1" + "0".repeat(18)
                                    }
                                },
                                to: {
                                    chain: to.chain,
                                    tx: new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                                        var toTxHash;
                                        var _this = this;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.getBridgeTxFor(fromTx.hash, targetNetworkId)];
                                                case 1:
                                                    toTxHash = _a.sent();
                                                    resolve({
                                                        hash: toTxHash,
                                                        wait: function (blockchainProvider_1) {
                                                            var args_1 = [];
                                                            for (var _i = 1; _i < arguments.length; _i++) {
                                                                args_1[_i - 1] = arguments[_i];
                                                            }
                                                            return __awaiter(_this, __spreadArray([blockchainProvider_1], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                                                var _this = this;
                                                                if (confirmations === void 0) { confirmations = 0; }
                                                                return __generator(this, function (_a) {
                                                                    return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                                            var _a;
                                                                            return __generator(this, function (_b) {
                                                                                switch (_b.label) {
                                                                                    case 0:
                                                                                        if (!blockchainProvider) return [3 /*break*/, 2];
                                                                                        _a = resolve;
                                                                                        return [4 /*yield*/, blockchainProvider.getTxBlockHash(toTxHash, targetNetworkId)];
                                                                                    case 1:
                                                                                        _a.apply(void 0, [_b.sent()]);
                                                                                        _b.label = 2;
                                                                                    case 2:
                                                                                        reject("BlockchainProvider is undefiend");
                                                                                        return [2 /*return*/];
                                                                                }
                                                                            });
                                                                        }); })];
                                                                });
                                                            });
                                                        }
                                                    });
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }),
                                    fee: {
                                        token: "0x0000000000000000000000000000000000000000",
                                        quantity: "1" + "0".repeat(18)
                                    }
                                },
                                by: config_1.BridgeName.Milkomeda
                            }];
                }
            });
        });
    };
    MilkomedaBridgeProvider._name = config_1.BridgeName.Milkomeda;
    MilkomedaBridgeProvider._bridgeAbi = MilkomedaBridgeAbi;
    return MilkomedaBridgeProvider;
}());
exports.default = MilkomedaBridgeProvider;
